import React, { useState, useCallback, Fragment } from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Button from '../../../Buttons/Button';
import LoadingSpinner from '../../../LoadingSpinner';
import Tooltip from '../../../Tooltip';
import AuthorizeConnectionModal from './AuthorizeConnectionModal';

const PushToSalesforceButton = ({ permissions, salesforceAccountUrl, isLoading, handleClick }) => {
  const { salesforce_current_status, salesforce_login_url } = permissions;
  const isDone = salesforce_current_status === 'done';
  const isNoConnection = salesforce_current_status === null;
  const isInProgress = salesforce_current_status === 'in_progress';
  const isError = salesforce_current_status === 'error';

  const [openAuthorizeModal, setOpenAuthorizeModal] = useState(false);

  const handleOpenModal = useCallback(() => setOpenAuthorizeModal(true), []);
  const handleCloseModal = useCallback(() => setOpenAuthorizeModal(false), []);

  let tooltipText = '';
  if (isInProgress) {
    tooltipText = 'Your connection is currently syncing. We will notify you when complete.';
  } else if (isError) {
    tooltipText = 'Error';
  }

  if (salesforceAccountUrl) {
    return (
      <Button variant="secondary" href={salesforceAccountUrl} target="_blank">
        <span className="prospects-sidebar__header-max-btn-text">View in Salesforce</span>
        <span className="hicon-arrow-right-circle-2" />
      </Button>
    );
  }

  return (
    <Fragment>
      <Tooltip placement="bottomRight" overlayStyle={{ maxWidth: 198 }} content={tooltipText}>
        <div>
          <Button
            variant="secondary"
            disabled={(isDone && isLoading) || isInProgress || isError}
            className={cx({ loading: isLoading })}
            onClick={isNoConnection ? handleOpenModal : handleClick}
          >
            <span className="prospects-sidebar__header-max-btn-text">Push to Salesforce</span>
            {isDone && isLoading && <LoadingSpinner size="sm" id="salesforce-spinner" />}
            {!isLoading && <span className="hicon-arrow-right-circle-2" />}
          </Button>
        </div>
      </Tooltip>
      <AuthorizeConnectionModal
        open={openAuthorizeModal}
        loginUrl={salesforce_login_url}
        onClose={handleCloseModal}
      />
    </Fragment>
  );
};

PushToSalesforceButton.propTypes = {
  permissions: T.object.isRequired,
  salesforceAccountUrl: T.oneOfType([T.string, T.bool]),
  isLoading: T.bool,
  handleClick: T.func.isRequired,
};

export default PushToSalesforceButton;
